<template>
  <div class="dsf-project-nationaldata-box" ref="scrollContainer" @scroll="handleScroll">
    <floatContainer v-if="$route.name === 'home'" />
    <el-container class="dsf-project-nationaldata" id="nationalCon">
      <a
        style="height: 56px; padding-top: 12px; background: #fafafa; display: block; box-sizing: border-box; padding-left: 158px; cursor: pointer"
        href="https://www.stats.gov.cn/"
        target="_self"
      >
        <img style="width: 140px" src="../../../assets/styles/img/cydc2025logo.png" />
      </a>
      <el-header class="dsf-project-nationaldata-header">
        <div class="header-top">
          <template v-if="isLogin">
            <span class="user-name">{{ $t("national.index.welcome") }},{{ userName }}</span>
            <a class="link-item" @click="handleSetting" v-show="!isEditPassword">{{ $t("national.index.setting") }}</a>
            <a class="link-item" @click="handleLogout">{{ $t("national.index.Logout") }}</a>
          </template>
          <template v-else>
            <a class="link-item" :href="'#/pc/national' + $t('national.urlBase') + '/login'">{{ $t("national.index.login") }}</a>
            <a class="link-item" :href="'#/pc/national' + $t('national.urlBase') + '/register'">{{ $t("national.index.signUp") }}</a>
          </template>
          <a v-if="$root._isEn" class="link-item" @click.stop="goNbs">NBS</a>
          <a class="link-item zhihuan" @click.stop="changeLangs">
            <i class="iconfont icon-zhihuan"></i>
            {{ showLangs }}
          </a>
        </div>
        <div class="header-content">
          <img class="header-login" v-if="$root._isEn" src="../../../assets/styles/img/logo_en.png" />
          <img class="header-login" v-else src="../../../assets/styles/img/logo.png" />
          <div class="header-right" v-if="!$root._isEn" v-show="!isEditPassword">
            <img src="../../../assets/styles/img/chashu.png" @click="chashuClick" />
            <div class="header-right-center">
              <div class="header-right-btns">
                <a class="btns-item" v-for="btn in btns" :key="btn.text" @click.stop.prevent="clickTipBtn(btn)">{{ btn.text }}</a>
              </div>
              <div class="header-right-bottom">
                <el-input placeholder="如：2012年 北京 GDP" v-model="searchValue" class="search-input" @keyup.enter.native="handleSearch">
                  <el-button slot="append" class="search-btn-style" @click="handleSearch">搜索</el-button>
                </el-input>
              </div>
            </div>
          </div>
        </div>
      </el-header>
      <el-main class="dsf-project-nationaldata-main">
        <DsfNationalHomeNav :nativeTab.sync="nativeTab" v-show="!isEditPassword"></DsfNationalHomeNav>
        <div class="main-content">
          <div class="main-content-body">
            <router-view @handleChangeSearchValue="handleChangeSearchValue"></router-view>
            <div class="main-toolbar" v-if="!hiddenToolbar">
              <NationalFixedLink />
            </div>
          </div>
        </div>
      </el-main>
      <el-footer>
        <DsfNationalHomeContentBtm></DsfNationalHomeContentBtm>
        <template v-if="!$root._isEn">
          <DsfNationalFooter></DsfNationalFooter>
        </template>
        <template v-else>
          <DsfNationalEnFooter></DsfNationalEnFooter>
        </template>
      </el-footer>
    </el-container>
    <!-- 浏览器兼容性提示 -->
    <BrowserTip />
  </div>
</template>

<script>
import BrowserTip from "@/pc/components/national/common/browserTipBox.vue";

import floatContainer from "./page/floatContainer.vue";
export default {
  name: "National",
  components: {
    BrowserTip,
    floatContainer,
  },
  data() {
    return {
      btns: [
        { text: "GDP", url: "" },
        { text: "CPI", url: "" },
        { text: "总人口", url: "" },
        { text: "社会消费品零售总额", url: "" },
        { text: "粮食产量", url: "" },
        { text: "PMI", url: "" },
        { text: "PPI", url: "" },
        { text: "城镇居民人均可支配收入", url: "" },
      ],
      searchValue: "",
      nativeTab: "",
      isLogin: 0,
      userName: "",
      isEditPassword: false,
    };
  },
  watch: {
    $route: {
      handler(data) {
        if (data.name == "editPassword") {
          this.isEditPassword = true;
        } else {
          this.isEditPassword = false;
        }
        this.$nextTick(() => {
          let ele = document.getElementById("nationalCon");
          ele.scrollIntoView({ block: "start" });
        });
      },
      immediate: true,
    },
  },
  computed: {
    hiddenToolbar() {
      let route = this.$route.path;
      if (route.includes(`/national${this.$t("national.urlBase")}/login`) || route.includes(`/national${this.$t("national.urlBase")}/register`) || route == "/pc/national/home") {
        return true;
      }
      return false;
    },
    showLangs() {
      let lang = this.$t("national.reversalLang");
      lang = lang.charAt(0).toUpperCase() + lang.slice(1);
      return lang;
    },
  },
  created() {},
  mounted() {
    if (this.$route.query?.iframeuuid) {
      sessionStorage.setItem("iframeuuid", this.$route.query.iframeuuid);
    }
    this.$eventBus.$on("login", this.getLoginInfo);
    this.$eventBus.$on("logOut", this.removeCookies);
    this.getLoginInfo();
    this.changeTheme();
  },
  methods: {
    handleChangeSearchValue(val) {
      this.searchValue = val;
    },
    chashuClick() {
      this.$router.push({
        path: "/pc/national/searchHome",
      });
    },
    changeLangs() {
      let url = `#/pc/national${this.$t("national.tarnsUrl")}/home`;
      dsf.layer.openWindow(url, "_blank");
    },
    handleScroll: _.throttle(function () {
      this.$eventBus.$emit("containerBoxScroll", true);
    }, 100),
    getLoginInfo() {
      this.isLogin = dsf.cookies.get(this.$t("national.index.loginCookie")) == 1;
      this.userName = dsf.cookies.get(this.$t("national.index.userNameCookie"));
    },
    clickTipBtn(e) {
      if (e && this.searchValue != e.text) {
        this.searchValue = _.cloneDeep(e.text);
        this.handleSearch();
      }
    },
    handleSearch() {
      if (this.$route.path == "/pc/national/search") {
        this.$eventBus.$emit("research", this.searchValue);
      } else {
        this.$router.push({
          path: "/pc/national/search",
          query: {
            s: this.searchValue,
          },
        });
      }
    },
    changeTheme() {
      const classList = document.body.getAttribute("class").split(" ");
      classList.forEach(item => {
        if (item.includes("-theme")) {
          document.body.classList.remove(item);
        }
      });
      document.body.classList.add("darkblue-theme");
    },
    handleSetting() {
      this.$router.push({
        path: `/pc/national${this.$t("national.urlBase")}/updateUserinfo`,
      });
    },
    handleLogout() {
      dsf.layer
        .confirm({
          title: this.$t("national.placeholders.tips"),
          message: this.$t("national.placeholders.confirmLogout"),
          cancelButtonText: this.$t("national.placeholders.cancel"),
          confirmButtonText: this.$t("national.placeholders.confirm"),
          lockScroll: false,
        })
        .then(() => {
          this.$http.post("/publicrelease/web/external/user/loginOut").done(res => {
            if (res.success || res.state == 40000) {
              dsf.layer.message(this.$t("national.placeholders.logoutSuccess"), true);
              this.removeCookies();
              this.isLogin = false;
              this.$router.push({
                path: `/pc/national${this.$t("national.urlBase")}/home`,
              });
            } else {
              dsf.layer.message(res.message, false);
            }
          });
        })
        .catch(dsf.noop);
    },
    removeCookies() {
      dsf.cookies.remove(this.$t("national.index.loginCookie"));
      dsf.cookies.remove(this.$t("national.index.userIdCookie"));
      dsf.cookies.remove(this.$t("national.index.userNameCookie"));
      this.getLoginInfo();
    },
    goNbs() {
      dsf.layer.openWindow("https://www.stats.gov.cn/english", "_blank");
    },
  },
  beforeDestroy() {
    this.$eventBus.$off("login", this.getLoginInfo);
    this.$eventBus.$off("logOut", this.removeCookies);
  },
};
</script>
